exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-swiper-menu {\n  z-index: 40;\n  position: absolute;\n  height: 100%;\n  -webkit-transition: transform .3s linear;\n  -o-transition: transform .3s linear;\n  -ms-transition: transform .3s linear;\n  transition: transform .3s linear;\n}\n.uu5-bricks-swiper-menu-left {\n  left: 0;\n  transform: translateX(-100%);\n}\n.uu5-bricks-swiper-menu-right {\n  right: 0;\n  transform: translateX(100%);\n}\n.uu5-bricks-swiper-menu.uu5-bricks-swiper-menu-open {\n  transform: translateX(0);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/swiper-menu.less
// module id = 264
// module chunks = 0